import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../../preact-components/modal'
import InputGroup from '../../ui-components/InputGroup'
import ButtonControl from '../../../preact-components/button-control'
import RadioInputGroup from '../../ui-components/RadioInputGroup'
import classNames from 'classnames'

type Props = {
  customViewName: string,
  customViewRadioInput: string,
  isCustomView: boolean,
  onClose: () => void,
  onCustomViewNameChanged: (e: ChangeEvent) => void,
  onRadioButtonChanged: (option: string, idx: number) => void,
  onSaveCustomView: () => void,
  radioOptions: string[],
  showModal: boolean,
  errorMessage: string
}

const SaveCustomViewModal = (
  {
    customViewName,
    customViewRadioInput,
    isCustomView,
    onClose,
    onCustomViewNameChanged,
    onRadioButtonChanged,
    onSaveCustomView,
    radioOptions,
    showModal,
    errorMessage
  }: Props) => {
  return (
    <Modal isOpen={showModal} size='medium'>
      <ModalHeader title='Save view' onClose={onClose} />
      <ModalBody>
        {isCustomView && <RadioInputGroup
          title={''}
          options={radioOptions}
          onChange={onRadioButtonChanged}
          value={customViewRadioInput}
        />}
        <InputGroup
          error={errorMessage}
          formGroupClasses={classNames('custom-view-name-input', isCustomView ? ' custom-view-name-input--update' : null)}
          onChange={onCustomViewNameChanged}
          placeholder='Enter custom view name'
          title={isCustomView ? null : 'Custom view name'}
          value={customViewName}
          newStyle
        />
      </ModalBody>
      <ModalFooter>
        <ButtonControl title='Save view' variant='success' onClick={onSaveCustomView} class='qa-save-custom-view' newStyle size='medium' />
        <ButtonControl title='Cancel' onClick={onClose} newStyle size='medium' />
      </ModalFooter>
    </Modal>
  )
}

export default SaveCustomViewModal
